export interface TemplateItem {
  description: string
  name: string
  originType: string
  resourceAmount: number
  sceneIds: number[]
  templateId: string
  updateTime: string
  verificationModeIds: number[]
}

export interface TemplateSearchParams {
  page: number
  pageSize: number
  os?: string
  filterParams?: {
    name?: string
    originType?: string
    sortOrder?: string
    sortField?: string
    verificationModeIds?: number[]
    sceneIds?: number[]
  }
}

export interface TemplateResponse {
  list: TemplateItem[]
  total: number
}

export type TemplateType = 'OriginTypeSystem' | 'OriginTypeCustom'

import { t } from '@/i18n'

export const TEMPLATE_TYPES = [
  { value: 'OriginTypeSystem', label: t('系统内置') },
  { value: 'OriginTypeCustom', label: t('手动添加') },
] as const
